import { StateCreator } from 'zustand';

export interface UnsavedChangesRequest {
    heading?: string;
    message?: string;
    onDiscard: () => void;
    onStay: () => void;
    onSaveAndLeave?: () => Promise<boolean>;
}

export interface UnsavedChangesDialogSlice {
    unsavedChangesRequest: UnsavedChangesRequest | null;
    openUnsavedChangesDialog: (request: UnsavedChangesRequest) => void;
    closeUnsavedChangesDialog: () => void;
}

export const createUnsavedChangesDialogSlice: StateCreator<UnsavedChangesDialogSlice> = (set) => ({
    unsavedChangesRequest: null,
    openUnsavedChangesDialog: (request) => set({ unsavedChangesRequest: request }),
    closeUnsavedChangesDialog: () => set({ unsavedChangesRequest: null })
});
